import { Utils } from "@/plugins/utils"

export default {
	namespaced: true,
	state: {
		lstCff: [],
		cff: null,
		insert: false,
		update: false,
		loading: false,
		itemsPerPage: 20,
		search: "",
		hasNext: false
	},
	actions: {
		initForm({ commit }) {
			commit("setInitForm")
		},
		setLoading({ commit }, loading) {
			commit("setLoading", loading)
		},
		setInsert({ commit }, insert) {
			commit("setInsert", insert)
		},
		setCff({ commit }, cff) {
			commit("setCff", cff)
		},
		setSearch({ commit }, search) {
			commit("setSearch", search)
		},
		async find({ commit, dispatch }, { cffcliente, cffinsest }) {
			commit("setLoading", true)
			commit("setInitForm")
			await this._vm.$axios
				.get(`/Customer/StateRegister/Find/?cffcliente=${cffcliente}&cffinsest=${cffinsest}`)
				.then(response => {
					let cff = Utils.ValidateAxiosResponse(response.data)
					commit("setCff", cff)
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message
						},
						{ root: true }
					)
				})
			commit("setLoading", false)
		},
		save({ dispatch, getters }) {
			if (getters.getUpdate) {
				return dispatch("update")
			}
			return dispatch("insert")
		},
		async insert({ commit, dispatch, getters }) {
			dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Salvando", indeterminate: true },
				{ root: true }
			)
			let payload = await this._vm.$axios
				.post("/Customer/StateRegister/Insert", getters.getCffModel)
				.then(response => {
					Utils.ValidateAxiosResponse(response.data)
					commit("setCff", null)
					return true
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message
						},
						{ root: true }
					)
					return false
				})
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return payload
		},
		async update({ commit, dispatch, getters }) {
			dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Salvando", indeterminate: true },
				{ root: true }
			)
			let payload = await this._vm.$axios
				.put("/Customer/StateRegister/Update", getters.getCffModel)
				.then(response => {
					Utils.ValidateAxiosResponse(response.data)
					commit("setCff", null)
					return true
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message
						},
						{ root: true }
					)
					return false
				})
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return payload
		},
		async setMain({ commit, dispatch, getters }) {
			dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Salvando", indeterminate: true },
				{ root: true }
			)
			let cff = getters.getCffModel
			let payload = await this._vm.$axios
				.put("/Customer/StateRegister/SetMain", cff)
				.then(async response => {
					let res = Utils.ValidateAxiosResponse(response.data)
					if (res) {
						commit("setCff", null)
						return await dispatch("find", { cffcliente: cff.cffcliente, cffinsest: cff.cffinsest })
					}
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message
						},
						{ root: true }
					)
					return false
				})
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return payload
		},
		async delete({ dispatch, getters }) {
			dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Excluindo", indeterminate: true },
				{ root: true }
			)
			await this._vm.$axios
				.delete(
					`/Customer/StateRegister/Delete/?cffcliente=${getters.getCffModel.cffcliente}&cffinsest=${getters.getCffModel.cffinsest}`
				)
				.then(response => {
					Utils.ValidateAxiosResponse(response.data)
					return true
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message
						},
						{ root: true }
					)
					return false
				})
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
		},
		async findList({ commit, dispatch, getters }) {
			commit("setLoading", true)
			commit("setInitForm")
			await this._vm.$axios
				.get("/Customer/StateRegister/FindList")
				.then(response => {
					let lstCff = Utils.ValidateAxiosResponse(response.data)
					commit("setLstCff", lstCff)
					commit("setHasNext", lstCff.length > getters.getItemsPerPage)
				})
				.catch(error => {
					commit("setLstCff", [])
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message
						},
						{ root: true }
					)
					return false
				})
			commit("setLoading", false)
		},
		async search({ commit, dispatch, getters }, { limit = 20, page = 1 }) {
			commit("setLoading", true)
			commit("setInitForm")
			let payload = await this._vm.$axios
				.get(`/Customer/StateRegister/Search?search=${getters.getSearch}&limit=${limit}&page=${page}`)
				.then(response => {
					let payload = Utils.ValidateAxiosResponse(response.data)
					commit("setParamsDataTable", payload)
					return true
				})
				.catch(error => {
					commit("setLstCff", [])
					commit("setSearch", "")
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message
						},
						{ root: true }
					)
					return false
				})
			commit("setLoading", false)
			return payload
		}
	},
	mutations: {
		setLstCff(state, lstCff) {
			state.lstCff = lstCff
		},
		setCff(state, cff) {
			state.cff = cff
			if (cff) state.update = true
		},
		setLoading(state, loading) {
			state.loading = loading
		},
		setInitForm(state) {
			state.insert = false
			state.update = false
			state.cff = null
		},
		setParamsDataTable(state, payload) {
			state.lstCff = payload.items
			state.itemsPerPage = payload.limit
			state.hasNext = payload.hasNext
		},
		setHasNext(state, hasNext) {
			state.hasNext = hasNext
		},
		setSearch(state, search) {
			state.search = search
		},
		setInsert(state, insert) {
			state.insert = insert
		}
	},
	getters: {
		getItemsPerPage(state) {
			return state.itemsPerPage
		},
		getCffModel(state) {
			return state.cff
		},
		getLstCff(state) {
			return state.lstCff
		},
		getLoading(state) {
			return state.loading
		},
		getUpdate(state) {
			return state.update
		},
		getInsert(state) {
			return state.insert
		},
		getSearch(state) {
			return state.search
		}
	}
}
